import React from "react";

const Team = (props) => {
  return (
    <img className="photos_slider--photo" src={props.team.teamImg} alt={props.team.teamAlt} />
  );
};

export default Team;